import { render, staticRenderFns } from "./rightFix.vue?vue&type=template&id=01b59de6&scoped=true"
import script from "./rightFix.vue?vue&type=script&lang=js"
export * from "./rightFix.vue?vue&type=script&lang=js"
import style0 from "./rightFix.vue?vue&type=style&index=0&id=01b59de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b59de6",
  null
  
)

export default component.exports